import { Configuration } from '@/api/index';
import { toOrderPrediction } from '@/api/mappers/mapOrderPrediction';
import {
  GenerateOrderPredictionRequest as ApiGenerateOrderPredictionRequest,
  OrderPredictionApi as ApiOrderPredictionApi,
} from '@/gen/api';
import { OrderPrediction, OrderPredictionStatus } from '@/models/OrderPrediction';

interface OrderPredictionsApi {
  generateOrderPrediction(): Promise<OrderPrediction | undefined>;
  getOrderPredictionStatus(): Promise<OrderPredictionStatus | undefined>;
  getOrderPrediction(id: string): Promise<OrderPrediction | undefined>;
}

export class OrderPredictionsApiImpl implements OrderPredictionsApi {
  private orderPredictionsApi: ApiOrderPredictionApi;

  constructor(configuration: Configuration) {
    this.orderPredictionsApi = new ApiOrderPredictionApi(configuration);
  }

  async generateOrderPrediction(): Promise<OrderPrediction | undefined> {
    const req: ApiGenerateOrderPredictionRequest = {
      orderPredictionRequest: {},
    };

    try {
      const result = await this.orderPredictionsApi.generateOrderPrediction(req);
      return toOrderPrediction(result);
    } catch (error) {
      console.error('Error generating order prediction:', error);
      throw error;
    }
  }

  async getOrderPrediction(_id: string): Promise<OrderPrediction | undefined> {
    return Promise.resolve(undefined);
  }

  async getOrderPredictionStatus(): Promise<OrderPredictionStatus | undefined> {
    try {
      return await this.orderPredictionsApi.getOrderPredictionStatus();
    } catch (error) {
      console.error('Error getting order prediction status:', error);
      throw error;
    }
  }
}

export default OrderPredictionsApi;
